// src/pages/Order Table.js
import React, { useEffect, useState } from 'react';
import styles from './OrderTable.module.css'
import axios from 'axios';
import DataTable from 'react-data-table-component';
import { Table, message, Button } from "antd"
import { MenuItem, Select } from '@mui/material';
import { FaCheck, FaSearch } from 'react-icons/fa';
import NotificationComponent from './notifications';
import { Link } from 'react-router-dom';
import APIURL from '../api/apiClient';




const OrderTable = () => {
  const [loading, setLoading] = useState(false);
  const [orderDetails, setOrderDetails] = useState([]);
  const [filterOrders, setFilterOrders] = useState([]);
  const [editedStatus, setEditedStatus] = useState('');
  const [lastOrderId, setLastOrderId] = useState(null);
  const [newOrderId, setNewOrderId] = useState(null); // Tracks the new order ID for notifications
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });


  const columns = [

    // {
    //   title: 'S.No',
    //   dataIndex: 'index',
    //   key: 'index',
    //   render: (text, record, index) => <div>{index + 1}</div>,
    //   width: 60,
    // },

    {
      title: 'S.No',
      dataIndex: 'index',
      key: 'index',
      render: (text, record, index) => {
        // Calculate the correct serial number based on the current page
        const pageSize = 10; // Replace with your actual page size
        const currentPage = pagination.current || 1; // Assuming currentPagination holds the pagination info
        return <div>{(currentPage - 1) * pageSize + index + 1}</div>;
      },
      width: 60,
    },

    {
      title: 'Order ID',
      dataIndex: "order_id",
      render: (order_id) => {
        return (
          <div>
            <Link to={`/ordersummary/${order_id}`} style={{ textDecoration: 'none', }}>{order_id}</Link>
          </div>
        );
      },
      width: 60,
    },
    {
      title: 'Name',
      dataIndex: "user_name",
      width: 100,
    },

    {
      title: 'Amount',
      dataIndex: "order_total",
      width: 200,
    },

    {
      title: 'Order Status',
      dataIndex: 'order_status',
      key: 'order_status',
      render: (order_status, row) => {
        // Define a color mapping object
        // const statusColors = {
        //   Processing: { backgroundColor: 'rgb(228, 236, 113)', color: 'black' },
        //   // pending: { backgroundColor: 'yellow', color: 'black' },
        //   Shipped: { backgroundColor: 'greenyellow', color: 'black' },
        //   Delivered: { backgroundColor: 'green', color: 'white' },
        //   Cancelled: { backgroundColor: 'red', color: 'white' },
        // };

        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <Select
              value={editedStatus[row.order_id] || order_status} // Use edited status if available
              onChange={(e) => handleSelectChange(row.order_id, e.target.value)} // Update local state
              style={{
                // padding: '5px',
                width: 150,
                height: 40,
                borderRadius: '5px',
                border: '1px solid #ccc',
                fontSize: '14px',
                // ...statusColors[order_status], // Apply dynamic styles
              }}
            >
              <MenuItem value="Processing">Processing</MenuItem>
              {/* <MenuItem value="Pending">Pending</MenuItem> */}
              <MenuItem value="Shipped">Shipped</MenuItem>
              <MenuItem value="Delivered">Delivered</MenuItem>
              <MenuItem value="Cancelled">Canceled</MenuItem>
            </Select>
            <Button
              onClick={() => handleSelectSubmit(row.order_id)} // Submit changes
              style={{
                padding: '5px 10px',
                borderRadius: '5px',
                backgroundColor: '#007bff',
                color: '#fff',
                border: 'none',
                cursor: 'pointer',
                fontSize: '18px',
              }}
            >
              <FaCheck />
            </Button>
          </div>
        );
      },
      width: 200,
    },

    // {
    //   title: 'Coupon Amount',
    //   dataIndex: "coupon_discount_amount"
    // },

    {
      title: 'Payment Status',
      dataIndex: "payment_status",
      width: 200,
      render: (text) => text ? text : '__',
    },

    // {
    //   title: 'Total Tax',
    //   dataIndex: "total_tax_amount"
    // },

    {
      title: 'Payment Method',
      dataIndex: "payment_method",
      width: 200,
      render: (text) => text ? text : '__',
    },

    {
      title: 'Delivery Address',
      dataIndex: "address",
      width: 700,
      render: (text) => text ? text : '__',
    },

    // {
    //   title: 'Coupon Code',
    //   dataIndex: "coupon_code"
    // },

    // {
    //   title: 'Order Type',
    //   dataIndex: "order_type"
    // },

    // {
    //   title: 'Schedule Time',
    //   dataIndex: "schedule_at"
    // },

    // {
    //   title: 'Canceled',
    //   dataIndex: "canceled",
    //   render: (canceled) => (canceled === 1 ? "Yes" : "No"), // Conditional rendering
    // },

    // {
    //   title: 'Refund Request',
    //   dataIndex: "refund_requested",
    //   render: (refund_requested) => (refund_requested === 1 ? "Yes" : "No"),
    // },

    // {
    //   title: 'Refunded',
    //   dataIndex: "refunded",
    //   render: (refunded) => (refunded === 1 ? "Yes" : "No")
    // },

    // {
    //   title: 'Shop Discount',
    //   dataIndex: "store_discount_amount"
    // },

    // {
    //   title: 'Order Attachment',
    //   dataIndex: "order_attachment"
    // },

    // {
    //   title: 'Tax Status',
    //   dataIndex: "tax_status",
    //   render: (tax_status) => (tax_status === 1 ? "Yes" : "No")
    // },

    // {
    //   title: 'Cancellation reason',
    //   dataIndex: "cancellation_reason"
    // },

    // {
    //   title: 'Canceled By',
    //   dataIndex: "canceled_by"
    // },

    // {
    //   title: 'Delivery Instruction',
    //   dataIndex: "delivery_instruction"
    // },

    // {
    //   title: 'Tax Percentage',
    //   dataIndex: "tax_percentage"
    // },

    // {
    //   title: 'Order Proof',
    //   dataIndex: "order_proof"
    // },

    // {
    //   title: 'Partially Paid  Amount',
    //   dataIndex: "partially_paid_amount"
    // },

    // {
    //   title: 'Consignment NO',
    //   dataIndex: "consignment_no"
    // },

  ]


  useEffect(() => {
    const fetchOrders = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${APIURL.baseURL}/fetchorders.php`);

        let orders = response.data;

        // ✅ Ensure the response is an array
        if (!Array.isArray(orders)) {
          console.warn("Expected an array but got:", typeof orders, orders);
          orders = []; // fallback to empty array
        }

        // ✅ Check if array has items
        if (orders.length > 0) {
          const latestOrderId = orders[orders.length - 1].order_id;
          console.log("Fetched latest order ID:", latestOrderId);

          if (lastOrderId === null) {
            setLastOrderId(latestOrderId); // First load, no notification
          } else if (latestOrderId !== lastOrderId) {
            console.log(`New order detected! Previous ID: ${lastOrderId}, New ID: ${latestOrderId}`);
            setLastOrderId(latestOrderId);
            setNewOrderId(latestOrderId);
          }
        }

        // ✅ Always update state
        setOrderDetails(orders);
        setFilterOrders(orders);
        console.log("Fetched orders:", orders);

      } catch (error) {
        console.error("Error fetching orders:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
    const interval = setInterval(fetchOrders, 15000);
    return () => clearInterval(interval);
  }, [lastOrderId]);



  const handlefilterOrders = (event) => {
    const searchValue = event.target.value.toLowerCase();

    const newData = filterOrders.filter(order => {
      const idMatch = order.order_id?.toString().includes(searchValue);
      const nameMatch = order.user_name
        ? order.user_name.toLowerCase().includes(searchValue)
        : false;

      return idMatch || nameMatch;

    });
    setOrderDetails(newData)

  };



  const handleTableChange = (pagination) => {
    setPagination(pagination);
  }




  //Function to handle dropdown change (local state update)
  const handleSelectChange = async (order_id, newStatus) => {
    setEditedStatus((prevState) => ({
      ...prevState,
      [order_id]: newStatus, // Track changes by id
    }));
    console.log(`Order ID: ${order_id}, New Status: ${newStatus}`);
  };


  // Function to handle submit (send to backend)
  const handleSelectSubmit = async (order_id) => {
    const newStatus = editedStatus[order_id]; // Get the updated status for this order
    if (!newStatus) {
      console.warn('No changes to submit');
      return;
    }

    // Confirm before submitting
    const confirm = window.confirm("Would you like to change the order status?");
    if (!confirm) {
      console.log('User canceled the status change.');
      return; // Exit if the user doesn't confirm
    }

    try {
      console.log('Submitting:', { order_id, new_status: newStatus });

      // Call backend API
      const response = await axios.post(
        `${APIURL.baseURL}/updateorderstatus.php`,
        { order_id, new_status: newStatus },
        { headers: { 'Content-Type': 'application/json' } }
      );

      if (response.data.success) {
        message.success(`Order Status Updated Successfully for Order ID: ${order_id}`);
        console.log('Status updated successfully');

        // Update local order details
        setOrderDetails((prevDetails) =>
          prevDetails.map((order) =>
            order.order_id === order_id ? { ...order, order_status: newStatus } : order
          )
        );

        // Remove from editedStatus
        setEditedStatus((prevState) => {
          const { [order_id]: removed, ...rest } = prevState;
          return rest;
        });
      } else {
        console.error('Failed to update status:', response.data.message);
        message.error(response.data.message || 'Failed to update order status');
      }
    } catch (error) {
      console.error('Error updating status:', error);
      message.error('Error updating order status');
    }
  };

  return (
    <div className={styles.orderPage}>
      <div className={styles.searchWrapper}>
        <div className={styles.input_wrapper}>
          <FaSearch className={styles.search_icon} />
          <input placeholder='Search Order' onChange={handlefilterOrders} className={styles.input_search} />
        </div>
      </div>

      <div className={styles.orders_container}>
        <div className={styles.scroll_wrapper}>
          <Table
            title={() => (
              <div className={styles.tableTitle}>Order Details</div>
            )}
            columns={columns.map((col) => ({
              ...col,
              onHeaderCell: () => ({
                style: {
                  background: 'linear-gradient(135deg, #f0f9ff 0%, #e6f7ff 100%)',
                  fontWeight: 'bold',
                  fontSize: '18px',
                  padding: '20px',
                  textAlign: 'center',
                  minWidth: '150px',
                  height: '100px',
                },
              }),
              onCell: () => ({
                style: {
                  textAlign: 'center',
                  padding: '20px',
                  fontSize: '18px',
                  height: '120px',
                  minWidth: '150px',
                },
              }),
            }))}
            dataSource={orderDetails}


            // 🔹 Show loading spinner inside the table
            loading={{
              spinning: loading, // your state variable
              tip: 'Loading orders...',
              size: 'large',
            }}

            // 🔹 Hide “No Data” text while loading
            locale={{
              emptyText: loading ? '' : 'No order details to display',
            }}

            scroll={{ x: 'max-content' }}
            pagination={{
              current: pagination.current,
              pageSize: pagination.pageSize,
              showSizeChanger: true,
              pageSizeOptions: ['10', '20', '50', '100'],
              defaultPageSize: 10,
            }}
            onChange={handleTableChange}
            className={styles.orderTable}
          />
        </div>
      </div>


      <NotificationComponent newOrderId={newOrderId} />
    </div>
  )

}

export default OrderTable;